<section class="pt-navigation-context">
    <dls-tabs class="pt-primary-navigation">
    <a index="0" *ngIf="showTab('info')" (click)="updateOpenPanel('info','TEST_INFO',true)"
       class="{{cssClassFormat('Test Info')}}" [ngClass]="{'pt-selected':'info' === selectedTab}">
      <span *ngIf="patientAnalyses.current.non_conformance_alert && configuration.QMSValues && configuration.QMSValues.available" class="pt-icon pt-inline-icon non_conformance_alert" [ngClass]="{'active-alerts':patientAnalyses.current.non_conformance_alert === 1}"></span>
      <span id="Test Info-tab-header">{{ (configuration.testInfoHeader ? configuration.testInfoHeader : 'Test Info') | translate}}</span>
    </a>

    <a index="1" *ngIf="showTab('specimens-and-samples')"
       (click)="updateOpenPanel('specimens-and-samples','SPECIMENS_AND_SAMPLES',true);"
       class="{{cssClassFormat('SPECIMENS AND SAMPLES')}}"
       [ngClass]="{'pt-selected':'specimens-and-samples' === selectedTab}">
        <span id="Specimens-And-Samples-tab-header">{{configuration.specimensTabConfig.specimensTabHeader | translate}}</span>
    </a>

    <a index="2" *ngIf="showTab('qc-results')" (click)="updateOpenPanel('qc-results','QC_RESULTS',true);"
       class="{{cssClassFormat('QC Results')}}" [ngClass]="{'pt-selected':'qc-results' === selectedTab}">
        <span id="QC results-tab-header">{{'QC Results' | translate }}</span>
    </a>

    <a index="3" *ngIf="showTab('aberrations')"
       (click)="updateOpenPanel('aberrations','GENOMIC_ABERRATIONS',true);"
       class="{{cssClassFormat('Genomic Aberrations')}}"
       [ngClass]="{'pt-selected':'aberrations' === selectedTab}">
        <span id="Genomic aberrations-tab-header">{{'Genomic Aberrations' | translate }}</span>
    </a>

    <a index="4" (click)="updateOpenPanel('prioritize','THERAPY_PRIORITIZE',true);"
       *ngIf="showTab('prioritize')" class="{{cssClassFormat('Therapies & Trials')}}"
       [ngClass]="{'pt-selected':'prioritize' === selectedTab}">
        <span id="Prioritization Preview-tab-header">{{'Therapies & Trials' | translate}}</span>
    </a>

    <a index="4" (click)="updateOpenPanel('therapy','THERAPY_MATCH',true);"
       *ngIf="showTab('therapy')" class="{{cssClassFormat('Therapy Match')}}"
       [ngClass]="{'pt-selected':'therapy' === selectedTab}">
        <span>{{ 'Therapy Match' | translate }}</span>
    </a>

    <a index="5" (click)="updateOpenPanel('trials','CLINICAL_TRAILS',true);"
       *ngIf="showTab('trials')" class="{{cssClassFormat('Clinical Trials')}}"
       [ngClass]="{'pt-selected':'trials' === selectedTab}">
        <span id="Clinical Trials-tab-header">{{ 'Clinical Trials' | translate }}</span>
    </a>

    <a index="5" (click)="updateOpenPanel('case-summary','CASE_SUMMARY',true);" *ngIf="showTab('case-summary')"
       class="{{cssClassFormat('case-summary')}}"
       [ngClass]="{'pt-selected':'case-summary' === selectedTab}">
        <span id="Case Summary-tab-header">{{ 'Case Summary' | translate }}</span>
    </a>

    <a index="6" (click)="updateOpenPanel('test-summary','TEST_SUMMARY',true);"
       *ngIf="showTab('test-summary')" class="{{cssClassFormat('Test Summary')}}"
       [ngClass]="{'pt-selected':'test-summary' === selectedTab}">
        <span id="Test Summary-tab-header">{{ 'Test Summary' | translate }}</span>
    </a>

    <a index="6" (click)="updateOpenPanel('reportPreview','REPORT_PREVIEW',true);"
       *ngIf="showTab('reportPreview')" class="{{cssClassFormat('Report Preview')}}"
       [ngClass]="{'pt-selected':'reportPreview' === selectedTab}">
        <span id="Report Preview-tab-header">{{ 'Report Preview' | translate }}</span>
    </a>

    <a index="1" (click)="updateOpenPanel('pathway-selection','PATHWAY_SELECTION',true);"
       *ngIf="showTab('pathway-selection')" class="{{cssClassFormat('Pathway Selection')}}"
       [ngClass]="{'pt-selected':'pathway-selection' === selectedTab}">
        <span id="Pathway Preview-tab-header">{{ 'Pathway Selection' | translate }}</span>
    </a>

    <a index="2" (click)="updateOpenPanel('therapy-prioritization','THERAPY_PRIORITIZATION',true);"
       *ngIf="showTab('therapy-prioritization')" class="{{cssClassFormat('Therapy Prioritization')}}"
       [ngClass]="{'pt-selected':'therapy-prioritization' === selectedTab}">
        <span id="TherapyPrioritization Preview-tab-header">{{ 'Therapy Prioritization' | translate }}</span>
    </a>

    <a index="3" (click)="updateOpenPanel('collect-data','COLLECT_DATA',true);" *ngIf="showTab('collect-data')"
       class="{{cssClassFormat('Consent form & report')}}"
       [ngClass]="{'pt-selected':'collect-data' === selectedTab}">
        <span id="CollectData Preview-tab-header">{{ 'Consent form & report' | translate }}</span>
    </a>

    <a index="4" (click)="updateOpenPanel('documents-preview','DOCUMENTS_PREVIEW',true);"
       *ngIf="showTab('documents-preview')" class="{{cssClassFormat('Consent form & report')}}"
       [ngClass]="{'pt-selected':'documents-preview' === selectedTab}">
        <span id="DocumentsPreview Preview-tab-header">{{ 'Consent form & report' | translate }}</span>
    </a>
</dls-tabs>
</section>
